import { ITicketData } from '@/types';
import { MessageSquare, Calendar, User, AlertCircle } from 'lucide-react';
import moment from 'moment';

interface RegularTicketProps {
  ticket: ITicketData;
}

export default function RegularTicket({ ticket }: RegularTicketProps) {
  return (
    <div className="flex flex-col gap-4 p-4">
      {/* Header */}
      <div className="flex items-center gap-3 rounded-lg border border-coal-200 bg-coal-50 p-4">
        <div className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-full bg-coal-200">
          <MessageSquare className="h-5 w-5 text-coal-600" />
        </div>
        <div>
          <p className="text-sm font-semibold text-coal-800">General Report</p>
          <p className="text-xs text-coal-500">Ticket #{ticket.ticket_code}</p>
        </div>
      </div>

      {/* Details */}
      <div className="rounded-lg border border-coal-200 divide-y divide-coal-100">
        <div className="flex items-start gap-3 p-3">
          <User className="mt-0.5 h-4 w-4 flex-shrink-0 text-coal-400" />
          <div>
            <p className="text-xs font-medium text-coal-400">Reported By</p>
            <p className="text-sm text-coal-800">{ticket.reporter_user?.user_name || 'Unknown'}</p>
          </div>
        </div>

        {ticket.reported_user?.user_name && (
          <div className="flex items-start gap-3 p-3">
            <User className="mt-0.5 h-4 w-4 flex-shrink-0 text-coal-400" />
            <div>
              <p className="text-xs font-medium text-coal-400">Reported User</p>
              <p className="text-sm text-coal-800">{ticket.reported_user.user_name}</p>
            </div>
          </div>
        )}

        <div className="flex items-start gap-3 p-3">
          <AlertCircle className="mt-0.5 h-4 w-4 flex-shrink-0 text-coal-400" />
          <div>
            <p className="text-xs font-medium text-coal-400">Reason</p>
            <p className="text-sm text-coal-800 capitalize">{ticket.reason || 'Not specified'}</p>
          </div>
        </div>

        <div className="flex items-start gap-3 p-3">
          <Calendar className="mt-0.5 h-4 w-4 flex-shrink-0 text-coal-400" />
          <div>
            <p className="text-xs font-medium text-coal-400">Submitted</p>
            <p className="text-sm text-coal-800">{moment(ticket.createdAt).format('MMM DD, YYYY [at] HH:mm')}</p>
          </div>
        </div>
      </div>

      {ticket.comment && (
        <div className="rounded-lg border border-coal-200 p-4">
          <p className="mb-2 text-xs font-semibold uppercase tracking-wider text-coal-400">Description</p>
          <p className="text-sm leading-relaxed text-coal-700">{ticket.comment}</p>
        </div>
      )}

      {ticket.admin_feedback && (
        <div className="rounded-lg border border-primary/20 bg-primary/5 p-4">
          <p className="mb-2 text-xs font-semibold uppercase tracking-wider text-primary">Admin Response</p>
          <p className="text-sm leading-relaxed text-coal-700">{ticket.admin_feedback}</p>
        </div>
      )}
    </div>
  );
}
